import { render } from "./ExperienceSection.vue?vue&type=template&id=61c9b91c&scoped=true"
import script from "./ExperienceSection.vue?vue&type=script&lang=js"
export * from "./ExperienceSection.vue?vue&type=script&lang=js"

import "./ExperienceSection.vue?vue&type=style&index=0&id=61c9b91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c9b91c"]])

export default __exports__